import React from "react";
import { PieChart, Pie, Cell } from "recharts";

import cx from "classnames";
import styles from "./radialPieChart.module.scss";


const RadialPieChart = ({data}) => {
  return (
    <div className={styles.container}>
      <PieChart width={150} height={150}>
        <Pie
          data={data}
          innerRadius={50}
          outerRadius={60}
          startAngle={90}
          endAngle={-270}
          paddingAngle={4}
          dataKey="value"
          stroke="none"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
}

export default RadialPieChart;
